import React from 'react';
import { useQuery } from 'react-query';

import styled from 'styled-components';

import { getAdditionalLinks } from 'apis/CommunityAPI';
import { useAppSelector } from 'store/hook';

import AdditionalLinksEditModal from './AdditionalLinksEditModal';
import Header from '../../common/header/Header';
import { useCommunityInfoContext } from '../../CommunityInfoContext';
import { formatUrl } from '../utils';

const Container = styled.div`
  position: relative;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
`;

const Label = styled.p`
  color: var(--text-primary);
  font-family: var(--font-bold);
`;

const Link = styled.a`
  color: var(--dark-blue);
  font-size: 14px;
  font-family: var(--font-regular);
  text-align: right;
  word-wrap: break-word;
  width: 60%;
`;

const AdditionalLinks = () => {
  const { currentUser } = useAppSelector((state) => state.auth);
  const hasPricingDataAccess = Boolean(currentUser?.isSuperuser || currentUser?.feature_flags?.view_pricing_data);
  const { communityInfo, isCompetitor } = useCommunityInfoContext();

  const { data, isSuccess, refetch } = useQuery({
    queryKey: ['community', 'additional', 'links', communityInfo?.id],
    queryFn: () => getAdditionalLinks(communityInfo?.id as number),
    enabled: Boolean(communityInfo),
  });

  const showEditButton = hasPricingDataAccess && !isCompetitor && isSuccess && currentUser?.isSuperuser;

  return (
    <Container>
      <Header
        title="Additional Links"
        controls={
          <AdditionalLinksEditModal
            type={'button'}
            show={showEditButton}
            buttonDataTestId="cd-edit-add-links-btn"
            onSuccess={refetch}
          />
        }
      />
      <Content>
        {data?.map((item: any) => (
          <Row key={item.id}>
            <Label>{item.description}</Label>
            <Link href={formatUrl(item?.page_url)} target="_blank" rel="noopener noreferrer">
              {item?.page_url}
            </Link>
          </Row>
        ))}
        {!data?.length && (
          <AdditionalLinksEditModal
            type={'link'}
            show={showEditButton}
            linkDataTestId="cd-add-add-links-link"
            onSuccess={refetch}
          />
        )}
      </Content>
    </Container>
  );
};

export default AdditionalLinks;
